export default __webpack_public_path__ + "static/media/icon3.a514ad9b.svg";